export default __webpack_public_path__ + "static/12-ed53cc1d6b55418f6d5e60c70532f15c.jpg";